import { Radio, RadioChangeEvent, Space } from "antd";
import { motion } from "framer-motion";
import { useExamStore } from "@store";
import { useState } from "react";

export const SingleChoiceOption = () => {
  const currentQuestion = useExamStore((state) => state.clickedQuestion);

  const [value, setValue] = useState<number>();

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Radio.Group value={value} onChange={onChange}>
        <Space direction="vertical">
          {currentQuestion?.answers.map((answer, index) => (
            <Radio key={index} value={index}>
              {answer.value}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </motion.div>
  );
};
